import React, { useState, useEffect } from 'react';
import { CustomModal, useCustomToast } from '../../../../components';
import { useManageStatus, useUpdateGestorEntryStatus } from '../../../../share';
import { useEntryGestorStatusolicitud } from '../../../../utils/validators/entry-request/entryGestorUpdateValidator';
import { TechnicalStatus } from '../../types/technical-type';
import { InventoryViewAPI } from '../../api/inventoryViewAPI';
import InventoryManageView from '../views/InventoryManageView';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import { useFetchTransferById, useFetchTransferByIdItems } from '../../../../hooks';

interface InventoryDetailContainerProps {
  isOpen: boolean;
  OnClose: () => void;
  technicalId?: string;
  onViewDetail: (id: string) => void;
}

const TechnicalConceptDetailContainer: React.FC<InventoryDetailContainerProps> = ({
  isOpen,
  OnClose,
  technicalId,
  onViewDetail,
}) => {
  const [footerLeft, setFooterLeft] = useState<React.ReactNode>(null);
  const { mutateAsync: updateGestorStatus } = useUpdateGestorEntryStatus();
  const { data: entryPetition } = useManageStatus('EntryPetition');
  const [shouldResetView, setShouldResetView] = useState(false);
  const [modalSignConfirmOpen, setModalSignConfirmOpen] = React.useState(false);

  const { showToast } = useCustomToast();

  const { data: detailData, isPending: isLoading, refetch: refetchDetailData } = useFetchTransferById(technicalId);

  const { data: items, isLoading: loadingItems, refetch: refetchItems } = useFetchTransferByIdItems(
    technicalId
  );

  const [updates, setUpdates] = useState<
  { id: string; status_id: string; observations: string }[]
>([]);

const [generalObservations, setGeneralObservations] = useState('');


  const onSaveSolicitud = async (values: any) => {
    const token = localStorage.getItem('auth');
    const tokenToJs = token ? JSON.parse(token).authorization.token : null;

    entryPetition?.forEach((item: any) => {
      if (item.id === values.status_id && item.name !== TechnicalStatus.DEVUELTO) {
        formikSolicitud.setFieldValue('rejection_reason', '');
      }
    });

    const body = {
      status_id: values.status_id,
      rejection_reason: values.rejection_reason,
    };

    try {
      await updateGestorStatus({ body, token: tokenToJs, id: Number(detailData?.id) });
      closeModal();
    } catch (error) {
      console.error('Error al actualizar los ítems del gestor:', error);
    }
  };

  const formikSolicitud = useEntryGestorStatusolicitud({ onSubmit: onSaveSolicitud });



  useEffect(() => {
    if (isOpen) {
      setGeneralObservations('');
      setUpdates([]);
      setShouldResetView(true);
    }
  }, [isOpen]);
  
  const closeModal = () => {
    formikSolicitud.resetForm();
    setGeneralObservations('');
    setUpdates([]);
    setShouldResetView(true);
    OnClose();
  };
  

   const handleDownloadDocuments = async (ids: string[]) => {
      if (!technicalId) return;
  
      try {
        await InventoryViewAPI.downloadConceptDocuments(technicalId);
      } catch (error) {
        console.error('Error al descargar documentos:', error);
      }
    };
  

  const onSaveSolicitudManage = async () => {
    if (!technicalId) return;
  
    try {
      const payload = {
        observations: generalObservations,
        items: updates,
      };
  
      const response = await InventoryViewAPI.updateTransferStatus(technicalId, payload);
  
      if (response) {
        showToast('success', response.message || 'Solicitud actualizada con éxito');
      }
  
      await refetchDetailData();
      await refetchItems();
      OnClose();
    } catch (error) {
      console.error('Error al actualizar el estado de la solicitud:', error);
      showToast('error', 'Error inesperado al actualizar la solicitud');
    }
  };

  return (
    <CustomModal
      title={`Detalle traslados entre funcionarios - ${detailData?.ticket || 'N/A'}`}
      open={isOpen}
      onCancel={closeModal}
      width="95vw"
      isLoading={isLoading}
      footerLeft={footerLeft}
      onSave={() => {
        setModalSignConfirmOpen(true);
      }}
      labelSubmit="Guardar"
      labelCancel=""
    >
      <InventoryManageView
        detailData={detailData}
        setFooterLeft={setFooterLeft}
        onDocuments={handleDownloadDocuments}
        entryStates={entryPetition}
        formikSolicitud={formikSolicitud}
        onViewDetail={onViewDetail} 
        onSuccess={refetchDetailData}
        shouldReset={shouldResetView}
        updates={updates}
        setUpdates={setUpdates}
        generalObservations={generalObservations}
        setGeneralObservations={setGeneralObservations}
        dataItems={items}
      />
      <ModalSaveChanges
        title="Guardar cambios"
        textOne=" ¿Está seguro de gestionar esta solicitud de traslado?"
        textTwo="Una vez creado no podrá realizar cambios."
        open={modalSignConfirmOpen}
        width={900}
        isLoadingSave={false}
        onClose={() => setModalSignConfirmOpen(false)}
        labelSubmit="Aceptar"
        onSave={async () => {
          setModalSignConfirmOpen(false);
          await onSaveSolicitudManage();
        }}
         />
    </CustomModal>
  );
};

export default TechnicalConceptDetailContainer;